module.exports = __webpack_public_path__ + "assets/e78376ed61884672a5e732bdcb752d8f.png";